// src/pages/Logout.jsx
import { useEffect } from 'react';
import { useLogout } from '../utils/authFunctions'; // Adjust the import path as needed

const Logout = () => {
  const logout = useLogout();

  useEffect(() => {
    logout();
  }, [logout]);

  return null; // This component doesn't render anything
};

export default Logout;
